import type { HttpService } from '@storebrand-digital/bank-foundation-http-service';

import type {
  SelfServiceBankAccountForChildModel,
  SelfServiceBankIdForChildModel,
  SelfServiceBankOrderPUMModel,
} from '@app/types/bank-afterloan-rest-api';

import ApiRoutePath, { ChildServices } from '../constants/apiRoutePath';
import type { Children, ParentInfo } from '../types';

export default class OnlineBankForChildrenService {
  #httpService: HttpService;

  constructor(httpService: HttpService) {
    this.#httpService = httpService;
  }

  getChildren = async () =>
    this.#httpService
      .get<Children>(ApiRoutePath.GET_CHILDREN)
      .then(({ data }) => data);

  getParentInfo = async () =>
    this.#httpService
      .get<ParentInfo>(ApiRoutePath.GET_PARENT_INFO)
      .then(({ data }) => data);

  postOrderPUMForChildren = async (
    payload: SelfServiceBankOrderPUMModel & { id: string }
  ) =>
    this.#httpService.post(
      `${ApiRoutePath.POST_ORDER_CHILD_SERVICE}/${payload.id}/${ChildServices.ORDER_PUM}`,
      payload
    );

  postOrderBankIdForChildren = async (
    payload: SelfServiceBankIdForChildModel & { id: string }
  ) =>
    this.#httpService.post(
      `${ApiRoutePath.POST_ORDER_CHILD_SERVICE}/${payload.id}/${ChildServices.ORDER_BANK_ID}`,
      payload
    );

  postOrderBankAccountForChildren = async (
    payload: SelfServiceBankAccountForChildModel & { childId: string }
  ) =>
    this.#httpService.post(
      `${ApiRoutePath.POST_ORDER_CHILD_SERVICE}/${payload.childId}/${ChildServices.ORDER_BANK_ACCOUNT}`,
      payload
    );
}
